import { render, staticRenderFns } from "./AnimalExit.vue?vue&type=template&id=284b6eb5&"
import script from "./AnimalExit.vue?vue&type=script&lang=js&"
export * from "./AnimalExit.vue?vue&type=script&lang=js&"
import style0 from "./AnimalExit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports